module.exports = __webpack_public_path__ + "d6996b811ebbd4734b74acdbfc834c8c.png";